module.exports = __webpack_public_path__ + "static/media/IHF_Logo_TransBG.49b14937.png";